// extracted by mini-css-extract-plugin
export default {"not-found-container":"PageNotFound_not-found-container__ZJNtZ","not-found-image":"PageNotFound_not-found-image__HkGgs","not-found-text":"PageNotFound_not-found-text__1eW+9"};